























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { EVENTS } from '../../../bus/events.const';

@Component
export default class IconColumnsPicker extends Vue {
  @Prop({ required: true })
  private columns: number[];

  @Prop({ required: true })
  private selectedColumnsNumber: number;

  @Prop({ default: 10 })
  private gap: number;

  private viewBoxSize = 100;

  private getRectSize(columnsNumber: number): number {
    return this.viewBoxSize / columnsNumber - this.gap;
  }

  private getRectPositionAndSize(columnsNumber: number, xIndex: number, yIndex: number) {
    const rectSize = this.getRectSize(columnsNumber);
    return {
      x: (this.viewBoxSize / columnsNumber) * (xIndex - 1) + this.gap / 2,
      y: (this.viewBoxSize / columnsNumber) * (yIndex - 1) + this.gap / 2,
      width: rectSize,
      height: rectSize
    };
  }

  private emitColumnsNumberChanged(columnsNumber: number) {
    this.$x.emit(EVENTS.ColumnNumberChanged, columnsNumber);
  }
}
